import { capitalize } from 'lodash-es';

import { OverrideStatusEnum } from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';

interface StatusFilterProps {
  selectedStatuses: OverrideStatusEnum[];
  onStatusChange: (statuses: OverrideStatusEnum[]) => void;
}

export function StatusFilter({
  selectedStatuses,
  onStatusChange,
}: StatusFilterProps) {
  const assignedStatuses: OverrideStatusEnum[] = [
    'assigned',
    'at dropoff',
    'at pickup',
    'canceled',
    'completed',
    'en route',
    'transporting',
  ];

  // Convert statuses to items with id for FilteredItemSelector
  const statusItems = assignedStatuses.map((status) => ({
    id: status,
    status,
  }));

  const selectedStatusItems = statusItems.filter((item) =>
    selectedStatuses.includes(item.status)
  );

  return (
    <ItemSelector
      items={statusItems}
      selectedItems={selectedStatusItems}
      loading={false}
      onSelectionChange={(items) => {
        onStatusChange(items.map((item) => item.status));
      }}
      getItemLabel={(item) => capitalize(item.status)}
      dataTestId="status-filter"
    />
  );
}
